import defaultWebInvoice from '#themes/default/web/pages/invoice/invoice.js';

import cBillingSummary from '#themes/avast/web/components/billingSummary/billingSummary.js';
import cButton from '#themes/avast/web/components/button/button.js';
import cCompanySummary from '#themes/avast/web/components/companySummary/companySummary.js';
import cOrderSummary from '#themes/avast/web/components/orderSummary/orderSummary.js';

export default {
	middleware: defaultWebInvoice.middleware,
	components: {
		cBillingSummary,
		cButton,
		cCompanySummary,
		cOrderSummary
	},
	extends: defaultWebInvoice
};
